module.exports = __webpack_public_path__ + "img/account_1000.476c212a.jpg";